import { FC } from "react";

import { Box } from "@mui/material";

import { getChoiceAvailableCount } from "../../../../components/CustomAnswer/choices.helper";
import { useLocaleContext } from "../../../../contexts/LocaleContext";
import * as useTranslate from "../../../../hooks/useTranslate";
import { getChoiceLabel } from "../../helpers/getLabel";

import { FormTypography } from "@/forms-design-system/FormTypography";
import { ChoiceOutput } from "@/types/trpc";

export interface QuestionFieldChoiceProps {
  choice: ChoiceOutput;
  answersOfParticipantsSelectedChoicesCount: Record<string, number> | undefined;
  hideAvailability?: boolean;
}

export const QuestionFieldChoice: FC<QuestionFieldChoiceProps> = ({
  choice,
  answersOfParticipantsSelectedChoicesCount,
  hideAvailability,
}) => {
  const { t } = useTranslate.useTranslate();
  const { locale } = useLocaleContext();
  const label = getChoiceLabel(choice.choiceFields || [], locale);
  const maximum = choice.maximum;
  const availableCount = getChoiceAvailableCount(choice, answersOfParticipantsSelectedChoicesCount);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        columnGap: 2,
      }}
    >
      {/* Label */}
      <FormTypography
        variant="body2"
        sx={{
          flexGrow: 1,
          whiteSpace: "normal",
        }}
        vibe="moderate"
        data-test="choice-label-typography"
      >
        {label}
      </FormTypography>

      {/* Availability */}
      {maximum !== null && maximum !== undefined && maximum >= 0 && !hideAvailability && (
        <FormTypography variant="caption" data-test="choice-label-available-typography" vibe="supershy">
          {availableCount > 0
            ? t("ticketing", "choice.availableCount", { count: availableCount })
            : t("ticketing", "choice.notAvailable")}
        </FormTypography>
      )}
    </Box>
  );
};
